import { Pagination_Button_default } from "./chunk-ANELDZQU.js";
import { Pagination_Item_default } from "./chunk-SWNM6ZEG.js";
import { Pagination_Items_default } from "./chunk-GZKEZNJ4.js";
import { Pagination_Label_default } from "./chunk-CLF45XTM.js";
import { Pagination_default } from "./chunk-WQBZM3PC.js";

// src/components/Pagination/index.ts
var PaginationComponent = Pagination_default;
PaginationComponent.Button = Pagination_Button_default;
PaginationComponent.Button.displayName = "Pagination.Button";
PaginationComponent.Items = Pagination_Items_default;
PaginationComponent.Items.displayName = "Pagination.Items";
PaginationComponent.Label = Pagination_Label_default;
PaginationComponent.Label.displayName = "Pagination.Label";
PaginationComponent.Item = Pagination_Item_default;
PaginationComponent.Item.displayName = "Pagination.Item";
export { PaginationComponent };